var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleAdsPopup',{staticStyle:{"margin":"0 auto"},attrs:{"path":"/22777916944/RTMKlik_Web_Interstitial_Banner_640x480","size":[640, 480],"id":"div-gpt-ad-1690964945987-0"}})}
var staticRenderFns = []

export { render, staticRenderFns }